import { render, staticRenderFns } from "./CaretRightIcon.vue?vue&type=template&id=28597523&"
import script from "./CaretRightIcon.vue?vue&type=script&lang=js&"
export * from "./CaretRightIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports